import React from 'react';
import { Link } from 'react-router-dom';

export default function OnsModel() {
  const steps = [
    { number: 1, title: 'Intake', description: 'Vrijblijvend kennismakingsgesprek om uw wensen te bespreken' },
    { number: 2, title: 'Offerte', description: 'Op maat gemaakte offerte met uren en tarieven' },
    { number: 3, title: 'Ureninkoop', description: 'Koop een strippenkaart met gewenst aantal uren' },
    { number: 4, title: 'Inzet', description: 'Flexibele inzet van psychiatrische expertise' },
  ];

  const benefits = [
    'Geen langdurige contracten',
    'Flexibele inzet',
    'Transparante facturatie',
    'Vrijgesteld van BTW',
    'Directe beschikbaarheid',
    'Breed inzetbaar',
  ];

  return (
    <>
      {/* Page Hero */}
      <section className="bg-[#2d5e5e] pt-32 pb-16 text-center text-white">
        <div className="max-w-6xl mx-auto px-5">
          <h1 className="text-3xl font-bold mb-3">Ons model</h1>
          <p className="text-lg opacity-90">Flexibele ureninkoop met transparante tarieven</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-24 bg-gray-100">
        <div className="max-w-6xl mx-auto px-5">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <p className="text-gray-600 leading-relaxed">
              Ons strippenkaartmodel biedt u de flexibiliteit om psychiatrische expertise in te zetten
              wanneer u dat nodig heeft, zonder langdurige verplichtingen.
            </p>
          </div>

          {/* Main Card */}
          <div className="bg-white rounded-2xl p-12 text-center shadow-xl border-4 border-[#a4cc3a] max-w-2xl mx-auto mb-16">
            <div className="w-20 h-20 bg-[#2d5e5e] rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="fas fa-ticket-alt text-3xl text-white"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Strippenkaart model</h2>
            <p className="text-gray-600 mb-8">
              Koop uren in bulk en zet deze flexibel in gedurende het afgesproken kwartaal.
              Volledige transparantie over bestede uren.
            </p>
            <div className="bg-gray-100 rounded-xl px-8 py-5 inline-flex items-baseline gap-3 mb-5">
              <span className="text-sm text-gray-600">Uurtarief:</span>
              <span className="text-3xl font-bold text-[#2d5e5e]">€ 190,-</span>
              <span className="text-sm text-gray-600">excl. BTW</span>
            </div>
            <p className="text-sm text-gray-600">
              <i className="fas fa-info-circle text-[#2d5e5e] mr-2"></i>
              Medische handelingen zijn vrijgesteld van BTW
            </p>
          </div>

          {/* Steps */}
          <div className="grid md:grid-cols-4 gap-6 mb-16">
            {steps.map((step) => (
              <div key={step.number} className="bg-white rounded-xl p-8 text-center shadow-md hover:shadow-lg hover:-translate-y-1 transition-all">
                <div className="w-12 h-12 bg-[#a4cc3a] rounded-full flex items-center justify-center mx-auto mb-5 text-xl font-bold text-[#1f4a4a]">
                  {step.number}
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-sm text-gray-600">{step.description}</p>
              </div>
            ))}
          </div>

          {/* Benefits */}
          <div className="bg-gray-200 rounded-2xl p-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Voordelen</h3>
            <div className="grid md:grid-cols-3 gap-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3 bg-white rounded-lg px-5 py-4">
                  <i className="fas fa-check-circle text-[#a4cc3a] text-lg"></i>
                  <span className="font-medium text-gray-700">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="bg-gray-200 rounded-2xl p-12 text-center mt-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">Direct berekenen?</h3>
            <p className="text-gray-600 mb-6">Gebruik onze calculator om uw investering te berekenen.</p>
            <Link to="/offerte" className="btn-primary">
              Naar offerte calculator
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
